import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { ManagementContractContext, updateManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { navigate } from "@my-dld/utils/StoreUtils";
import PickerInput from "@eres/forms-web/PickerInput";
import { IdExtractor, serverDateConverter } from "@my-dld/utils/LookupUtil";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import {
	ContractAmountTypes,
	FIXED_AMOUNT,
	FREE_OF_CHARGE,
	MCContractDetails,
	MCPaymentDetails,
	PERCENTAGE
} from "@eres/ejari-api/Entity/management_contract";
import _ from "lodash";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "../../utils";
import { AlphaSortProcessor, EJLookupTransformer, populateLookupOnTo, StateConsumer } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { Lookup } from "@eres/ejari-api/Entity";
import DateInputField from "@eres/forms-web/DateInputField";
import moment from "moment";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import TextInputField from "@eres/forms-web/TextInputField";
import CurrencyInputField from "@eres/forms-web/CurrencyInputField";
import { valueRenderer } from "../Contract/ContractCalculatedValue";
import PercentageInputField from "@eres/forms-web/PercentageInputField";
import { PaymentType } from "@eres/ejari-api/Entity/contract";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Companies?: Lookup[];
	Types?: Lookup[];
	Activities?: Lookup[];
	ContractValues?: Lookup[];
}

interface State extends LookupState, LoadableDataState {
	newData?: Partial<MCContractDetails>;
	orgData?: Partial<MCContractDetails>;
}

class ContractDetails extends Component<Props, State> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
            loadState: "loading",

			ContractValues: ContractAmountTypes,
		};
	}

	componentDidMount(): void {
		this.updateFromContext();
		populateLookupOnTo( EjariLookUp.MC_COMPANIES, StateConsumer( this, "Companies" ), EJLookupTransformer, AlphaSortProcessor );
		populateLookupOnTo( EjariLookUp.MC_TYPES, StateConsumer( this, "Types" ), EJLookupTransformer, AlphaSortProcessor );
		populateLookupOnTo( EjariLookUp.MC_ACTIVITIES, StateConsumer( this, "Activities" ), EJLookupTransformer );
	}

	render() {
		const { action } = this.context;
		const isRenew = action === TenancyContactAction.RENEW_CONTRACT;
		const { Companies, Activities, Types, ContractValues } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12",
			errorManager: defaultErrorManager,
		};
		const data = this.getUpdatedData();
		const maxStartDate = data.ContractEndDate?.asDate();
		const minEndDate = data.ContractStartDate ? moment( data.ContractStartDate?.asDate() ).add( 1, "month" ).toDate().asDate() : undefined;
		return <>
			<FormSection title={ Strings.contract_details }>
                <FormRow {...filedProps}>
                    <PickerInput
                        required={true}
                        id={"AgreementCompany"}
                        label={Strings.agreement_agencies}
                        isLoading={Companies === undefined}
                        valueManager={dualDataManager}
                        items={Companies}
                        toIdentifier={IdExtractor}
                        disabled={isRenew}/>
					<DateInputField
						required={ true }
						label={ Strings.agreement_from }
						id={ "ContractStartDate" }
						valueManager={ dualDataManager }
						inputProps={ { autoComplete: "off" } }
						extraOpts={ {
							maxDate: maxStartDate,
						} }
						valueConverter={ serverDateConverter }/>
					<DateInputField
						required={ true }
						label={ Strings.agreement_to }
						id={ "ContractEndDate" }
						valueManager={ dualDataManager }
						inputProps={ { autoComplete: "off" } }
						extraOpts={ {
							minDate: minEndDate,
						} }
                        valueConverter={serverDateConverter} />
                    <PickerInput
                        required={true}
                        id={"ManagementContractTypeId"}
                        label={Strings.agreement_type}
                        isLoading={Types === undefined}
                        valueManager={dualDataManager}
                        items={Types}
                        toIdentifier={IdExtractor}
                        disabled={isRenew} />
                    <PickerInput
                        required={true}
                        id={"ManagementContractActivityId"}
                        label={Strings.activity_type_mg}
                        valueManager={dualDataManager}
                        isLoading={Activities === undefined}
                        items={Activities}
                        toIdentifier={IdExtractor}
                        disabled={isRenew}>
                        
                    </PickerInput>
                    <PickerInput
                        required={true}
                        id={"contractValType"}
                        label={Strings.contract_type}
                        valueManager={dualDataManager}
                        isLoading={ContractValues === undefined}
                        items={ContractValues}
                        toIdentifier={IdExtractor} />
                </FormRow>
                <FormRow {...filedProps} containerClassName="col-12">
                    <div className="form-group">
                    {data.ManagementContractActivityId?.Id + "" === "2" ?
                        <CheckBoxField
                            {...filedProps}
                            label={Strings.business_activity_term}
                            id={"IsActivityAccepted"}
                            valueManager={dualDataManager}
                                /> : null}
                    </div>
					
				</FormRow>
				<FormRow { ...filedProps } containerClassName={ "col-12" }>
					
				</FormRow>
				{
					data.contractValType?.Id + "" === FREE_OF_CHARGE.Id + "" ?
						<FormRow { ...filedProps } containerClassName={ "col-12 form-group" }>
							<TextInputField
								label={ Strings.reason }
								required={ true }
								id={ "Reason" }
								valueManager={ dualDataManager }/>
						</FormRow> : null
				}
				{
					data.contractValType?.Id + "" === FIXED_AMOUNT.Id + "" ?
						<FormRow { ...filedProps }>
							<CurrencyInputField
								required={ true }
								textRenderer={ valueRenderer }
								id={ "FixedFee" }
								valueManager={ dualDataManager }
								label={ Strings.fixed_amount }/>
							<TextInputField
								id={ "NoOfPayments" }
								required={ true }
								type={ "number" }
								valueManager={ dualDataManager }
								label={ Strings.payment_count }
							/>
						</FormRow> : null
				}
				{
					data.contractValType?.Id + "" === PERCENTAGE.Id + "" ?
						<FormRow { ...filedProps } containerClassName={ "col-12 form-group" }>
							<PercentageInputField
								label={ Strings.percentage_of_rent_amount }
								required={ true }
								id={ "PercentageFee" }
								valueManager={ dualDataManager }/>
						</FormRow> : null
				}
			</FormSection>
			<FormRow>
				<FormAction
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
		</>;
	}

	private updateFromContext() {
		const { contractDetail } = this.context;
		const state = {
			orgData: contractDetail || {},
			newData: contractDetail || {},
		};
		this.setState( state );
	}

	private getUpdatedData = ( state: State = this.state ) => {
		const data: Partial<MCContractDetails> = {};
		_.merge( data, state.orgData, state.newData );
		return data;
	};

	private isValid() {
		const data = this.getUpdatedData();
		const error: ErrorContainer = {};
		let isValid = checkNonEmpty( data, "AgreementCompany", error );
		isValid = isValid && checkNonEmpty( data, "ContractStartDate", error );
		isValid = isValid && checkNonEmpty( data, "ContractEndDate", error );
		isValid = isValid && checkNonEmpty( data, "ManagementContractTypeId", error );
		isValid = isValid && checkNonEmpty( data, "ManagementContractActivityId", error );
		isValid = isValid && checkNonEmpty( data, "contractValType", error );
		if ( data.contractValType?.Id + "" === FREE_OF_CHARGE.Id + "" ) {
			isValid = isValid && checkNonEmpty( data, "Reason", error );
		} else if ( data.contractValType?.Id + "" === FIXED_AMOUNT.Id + "" ) {
			isValid = isValid && checkNonEmpty( data, "FixedFee", error );
			isValid = isValid && checkNonEmpty( data, "NoOfPayments", error );
		} else if ( data.contractValType?.Id + "" === PERCENTAGE.Id + "" ) {
			isValid = isValid && checkNonEmpty( data, "PercentageFee", error );
		}
		this.setState( {
			errorContainer: error,
		} );
		return isValid;
	}

	private onContinue = () => {
		if ( this.isValid() ) {
			const { contractDetail, payments } = this.context;
			const data = this.getUpdatedData();
			const merged = _.merge( contractDetail, data );
			const p: MCPaymentDetails[] = [];
			if ( data.contractValType?.Id + "" === FIXED_AMOUNT.Id + "" ) {
				data.Reason = undefined;
				data.PercentageFee = undefined;
				for ( let i = 0; i < Number( data.NoOfPayments ); i++ ) {
					const paymentData: Partial<MCPaymentDetails> = { PaymentTypeID: PaymentType.CASH };
					p.push( paymentData as MCPaymentDetails );
				}
			} else if ( data.contractValType?.Id + "" === PERCENTAGE.Id + "" ) {
				data.Reason = undefined;
			} else if ( data.contractValType?.Id + "" === FREE_OF_CHARGE.Id + "" ) {
				data.PercentageFee = undefined;
			}
			updateManagementContractContext( {
				...this.context,
				contractDetail: merged,
				payments: data.contractValType?.Id + "" === FIXED_AMOUNT.Id + "" ? payments && payments.length > 0 ? payments : p : []
			} );
			if ( data.contractValType?.Id + "" === FIXED_AMOUNT.Id + "" ) {
				navigate( "payment" );
			} else {
				navigate( "responsibilities" );
			}
		}
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default ContractDetails;
